import { typedQueryClient, useTypedQuery } from "hooks";
import { DMSv3CustomQueriesQueryKeys } from "modules/DMSv3/CustomQueries/queryKeys";

import type { DMSCustomQueryHistory } from "models";

export const useSelectedQuery = () => useTypedQuery({ queryKey: DMSv3CustomQueriesQueryKeys.selectedQuery, initialData: null });

export const setSelectedQuery = (query: DMSCustomQueryHistory | null) => typedQueryClient.setQueryData(DMSv3CustomQueriesQueryKeys.selectedQuery, query);
